<template>
    <div class="paper_upload_div">
        <form @submit.prevent="createPaperpileBeforeSubmitMethod">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input type="text" class="form-control" rows="4" v-validate="'required'" v-model="topic"
                            name="topic" v-bind:class="{ 'is-invalid': errors.has('topic') }" data-vv-as="topic">
                        <small class="invalid-feedback" v-if="errors.has('topic')">{{ errors.first('topic') }}</small>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="upload_attachment_btn">
                    <label for="upload_attachment">
                        <input type="file" id="upload_attachment" name="file" ref="file" v-validate="'required'"
                            @change="handleAttachmentUpload" v-bind:class="{ 'is-invalid': errors.has('file') }"
                            accept=".pdf" data-vv-as="file" />
                        <span class="upload_attachment_btn">
                            <template v-if="!this.uploadAttachmentName">
                                <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                Select PDF</template>
                            <template v-if="this.uploadAttachmentName">{{ this.uploadAttachmentName }}</template>
                        </span>
                    </label>
                </div>
                <small class="invalid-feedback d-block" v-if="errors.has('file')">{{ errors.first('file') }}</small>
                <div v-if="uploadProgress > 0 && submitted" class="uploading-progress-bar mt-4">
                    <h3 class="progress-filename">
                        <template v-if="uploadProgress == 100">Finishing...</template>
                        <template v-else>Uploading Files...</template>
                    </h3>
                    <div class="progress-bar" :style="{ width: uploadProgress + '%' }"></div>
                    <div class="progress-percentage">{{ uploadProgress }}%</div>
                </div>
            </div>
            <div class="form-group" v-if="encryptedToggle">
                <label>Pdf Password</label>
                <input type="text" class="form-control" v-model="pdf_password" name="pdf_password"
                    v-validate="'required'" v-bind:class="{ 'is-invalid': errors.has('topic') }"
                    data-vv-as="pdf password" v-on:keyup="keymonitor">
                <small class="invalid-feedback" v-if="errors.has('pdf_password')">{{ errors.first('pdf_password')
                }}</small>
            </div>
            <div class="form-group" v-if="passwordIncorrectState">
                <span class="incorrected_error_txt">Password Incorrected</span>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <button type="submit" class="btn btn-primary"
                        :disabled="submitted">Upload</button>
                </div>
            </div>
        </form>
        <!-- Update PP Details -->
        <update-pp-details v-if="updatePaperPileDetailPopupState"
            :paperUpdateINFO="paperUpdateInfo"></update-pp-details>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import { bus } from '@/main';
import root from '@/_helpers/roots';
import toast from '@/services/toast';
import updatePpDetails from '../../update-paperpile-details';
let paperUploadFromLocal = root.pdfPaperPileApiUrl.link;

export default {
    name: 'add-paper-from-local',
    components: {
        'update-pp-details': updatePpDetails
    },
    props: [],
    data() {
        return {
            submitted: false,
            file: null,
            uploadAttachmentName: '',
            topic: '',
            updatePaperPileDetailPopupState: false,
            paperUpdateInfo: null,
            encryptedToggle: false,
            pdf_password: '',
            passwordIncorrectState: false,
            uploadProgress: 0
        }
    },
    computed: {

    },
    mounted() {
        bus.$on('updatePaperPileDetailPopupStateBus', (data) => {
            this.updatePaperPileDetailPopupState = data;
        });
    },
    methods: {
        updatePaperInfoMethod(data) {
            this.paperUpdateInfo = data;
            this.updatePaperPileDetailPopupState = true;
            document.body.classList.add('body_right_scroll_remove');
        },
        getPaperPileListAgain() {
            this.$store.dispatch('getAllPaperPileFun');
        },
        handleAttachmentUpload(event) {
            var input = event.target;
            var reader = new FileReader();
            var _self = this
            reader.onload = function (event) {
                var contents = event.target.result;
                if (contents.indexOf('/Encrypt') !== -1) {
                    _self.encryptedToggle = true
                } else {
                    _self.encryptedToggle = false
                }
            };
            reader.readAsText(input.files[0]);
            if (event.target.files && event.target.files.length > 0) {
                this.file = event.target.files[0];
                this.files = this.$refs.file.files[0];
                this.uploadAttachmentName = this.files.name
            } else {
                this.uploadAttachmentName = '';
            }
        },
        createPaperpileBeforeSubmitMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {   
                    this.submitted = true
                    var formData = new FormData();
                    formData.append('file', this.file);
                    formData.append('title', this.topic);
                    formData.append('file_name', this.uploadAttachmentName);
                    formData.append('is_favourite', false);
                    formData.append('is_uploaded', true);
                    if (this.pdf_password != '') {
                        formData.append('pdf_password', this.pdf_password);
                    }
                    axios.post(paperUploadFromLocal, formData, {
                        onUploadProgress: progressEvent => {
                            this.uploadProgress = Math.round(
                                (progressEvent.loaded / progressEvent.total) * 100
                            );
                        },
                    }).then((res) => {
                        this.file = null;
                        this.topic = '';
                        this.uploadAttachmentName = '';
                        this.pdf_password = '';
                        this.$validator.reset();
                        toast.success(res.data.msg);
                        // this.getPaperPileListAgain()
                        bus.$emit('paperSelectedBus', res.data.data.id);
                        this.updatePaperInfoMethod(res.data.data);
                        this.uploadProgress = 0;
                        this.submitted = false;
                    }).catch((err) => {
                        if (err.status == '406') {
                            this.uploadProgress = 0;
                            this.submitted = false;
                            toast.error('The pdf file already exists');
                            bus.$emit('paperSelectedBus', err.data.data.id);
                        } else if (err.status == '409') {
                            this.uploadProgress = 0;
                            this.passwordIncorrectState = true;
                            this.submitted = false;
                            toast.error('PDF Password Incorrected');
                        }else if (err.status == '417') {
                            this.uploadProgress = 0;
                            this.submitted = false;
                        } else {
                            this.submitted = false
                            toast.error(err.data.user_msg || err.data.msg);
                        }
                    })
                    return;
                }
            })
        },
        keymonitor() {
            if (this.passwordIncorrectState == true) {
                this.passwordIncorrectState = false
            }
        }
    }
}
</script>


<style lang="scss" scoped>
.paper_upload_div {
    letter-spacing: 1px;
    label {
        font-size: 18px;
        margin-bottom: 4px;
    }
    .form-group{margin-bottom: 30px;}
    .form-control {
        width: 100%;
        font-weight: normal;
        font-size: 18px;
        border-radius: 10px;
        height: 48px;
        padding: 10px 20px;
        border: 1px solid rgba(255, 255, 255, 0.1);
        outline: none !important;
        box-shadow: none !important;
        color: #ffd400;
        background: rgba(255, 255, 255, 0.03);

        &:focus {
            border-color: #ffd400;
        }
    }

    .mx-datepicker {
        width: 100%;
    }

    .invalid-feedback {
        font-size: 14px;
        line-height: 1;
    }

    .upload_attachment_btn {
        label {
            position: relative;
            padding:60px 20px;
            background: rgba(255, 255, 255, 0.03);
            border: 1px solid rgba(255, 255, 255, 0.1);
            margin: 0;
            line-height: 1;
            border-radius: 10px;
            color: #fff;
            cursor: pointer;
            margin-bottom: 0px !important;
            word-break: break-all;
            width: 100%;
            text-align: center;
            font-size: 24px;

            &:hover {
                border-color: #ffd400;
                color: #ffd400;
            }
            .fa{margin-right: 10px;}
        }

        input[type="file"] {
            position: absolute;
            opacity: 0;
            display: none;
        }
    }

    .btn-primary {
        cursor: pointer;
        position: relative;
        min-width: 110px;
        box-shadow: none !important;
        outline: none !important;
        background: none !important;
        border: 2px solid #ffd400 !important;
        color: #ffd400;
        border-radius: 3px;
        font-size: 18px;
        line-height: 1;
        padding: 10px 0px;

        &:hover {
            background: #ffd400 !important;
            color: #22292f !important;
        }
    }

    .incorrected_error_txt {
        color: #dc3545;
        font-size: 16px;
    }

    .uploading-progress-bar {
        .progress-bar {
            height: 5px;
            background-color: #ffc107;
        }

        .progress-percentage {
            margin-top: 5px;
            text-align: center;
            color: #ffc107;
        }

        .progress-filename {
            color: #ffc107;
            font-size: 14px;
            text-align: center;
        }
    }
}
</style>